// The Forecasts panel's title search: whether its box is open and what is typed. Closing the
// panel ends the search, so the panel always reopens on the full list.
import { useCallback, useState } from "react";

/**
 * @param {{panelOpen: boolean}} deps
 * @returns {{open: boolean, query: string, setQuery: (q: string) => void, openSearch: () => void,
 *   close: () => void}}
 */
export function useForecastSearch({ panelOpen }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  // Adjusted while rendering (React's pattern for state that follows a prop), not in an effect,
  // so a reopened panel never paints one frame of the old filter.
  if (!panelOpen && (open || query)) {
    setOpen(false);
    setQuery("");
  }
  const openSearch = useCallback(() => setOpen(true), []);
  const close = useCallback(() => {
    setOpen(false);
    setQuery("");
  }, []);
  return { open, query: open ? query : "", setQuery, openSearch, close };
}
